import { useState, useEffect, useContext } from "react";
import { useDropdownData } from "./useDropdownData";
import GenericCombobox from "./GenericCombobox";

import { getpbStates, getpbCities, getpbAreas } from "../../utils/SonicAPIV2";

import {
  UilUser,
  UilEnvelopeAlt,
  UilLocationPinAlt,
  UilPhoneAlt,
  UilLocationPoint,
  UilMapMarker,
  UilMapPin,
  UilUserLocation,
  UilLockAccess,
} from "@iconscout/react-unicons";

const FIXED_Country = { countryId: 1, countryName: "UAE" };

export default function LocationSelectorForRegistration({
  onLocationChange,
  initialLocationValues,
}) {
  const [selectedCountry, setSelectedCountry] = useState(
    initialLocationValues?.country || FIXED_Country
  );
  const [selectedState, setSelectedState] = useState(
    initialLocationValues?.state || null
  );
  const [selectedCity, setSelectedCity] = useState(
    initialLocationValues?.city || null
  );
  const [selectedArea, setSelectedArea] = useState(
    initialLocationValues?.area || null
  );

  const countries = [FIXED_Country]; // Since country is fixed, we can directly use it without fetching

  //const { data: countries } = useDropdownData(getCountries, [], []);

  const { data: states } = useDropdownData(getpbStates, [1], [1]);

  const { data: cities } = useDropdownData(
    getpbCities,
    [selectedState?.stateId],
    [selectedState?.stateId]
  );

  const { data: areas } = useDropdownData(
    getpbAreas,
    [selectedCity?.cityId],
    [selectedCity?.cityId]
  );

  useEffect(() => {
    if (states?.length && initialLocationValues?.state) {
      const match = states.find(
        (s) => s.stateId === initialLocationValues.state.stateId
      );
      if (match) setSelectedState(match);
    }
  }, [states, initialLocationValues]);

  useEffect(() => {
    if (cities?.length && initialLocationValues?.city) {
      const match = cities.find(
        (c) => c.cityId === initialLocationValues.city.cityId
      );
      if (match) setSelectedCity(match);
    }
  }, [cities, initialLocationValues]);

  useEffect(() => {
    if (areas?.length && initialLocationValues?.area) {
      const match = areas.find(
        (a) => a.areaId === initialLocationValues.area.areaId
      );
      if (match) setSelectedArea(match);
    }
  }, [areas, initialLocationValues]);

  useEffect(() => {
    // Only call with the selected objects!
    if (selectedCountry && selectedState && selectedCity && selectedArea) {
      onLocationChange({
        country: selectedCountry,
        state: selectedState,
        city: selectedCity,
        area: selectedArea,
      });
      // console.log(
      //   "[LocationSelectorForRegistration] onLocationChange called with:",
      //   {
      //     country: selectedCountry,
      //     state: selectedState,
      //     city: selectedCity,
      //     area: selectedArea,
      //   }
      // );
    }
  }, [selectedCountry, selectedState, selectedCity, selectedArea]);

  return (
    <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-4">
      {/* Country Dropdown */}
      <div className="flex flex-row items-center">
        <div
          className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md
justify-start items-center gap-1 inline-flex"
        >
          <UilLocationPinAlt className="text-gray-500 w-4" />

          <div className="font-normal text-C12 w-12">Country</div>
        </div>

        <GenericCombobox
          label=""
          options={countries}
          selected={selectedCountry}
          onChange={(val) => setSelectedCountry(val)}
          displayKey="countryName"
          keyField={"countryId"}
          disabled={true}
        />
      </div>

      <div>
        {/* States Dropdown */}
        {states?.length > 0 && (
          <div className="flex flex-row items-center">
            <div
              className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md
justify-start items-center gap-1 inline-flex"
            >
              <UilLocationPoint className="text-gray-500 w-4" />
              <div className="font-normal text-C12 w-12">State</div>
            </div>

            <GenericCombobox
              label=""
              options={states}
              selected={selectedState}
              onChange={(val) => {
                setSelectedState(val);
              }}
              displayKey="statessName"
              keyField={"stateId"}
              className="block w-full rounded-none rounded-r border-0 px-3.5 py-2 text-gray-800 font-normal shadow-sm ring-1 ring-inset ring-secondaryHover
      placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
            />
          </div>
        )}
      </div>
      {cities?.length > 0 && (
        <div className="flex flex-row items-center">
          <div
            className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md
justify-start items-center gap-1 inline-flex"
          >
            <UilLocationPoint className="text-gray-500 w-4" />

            <div className="font-normal text-C12 w-12">City</div>
          </div>

          <GenericCombobox
            label=""
            options={cities}
            selected={selectedCity}
            onChange={(val) => setSelectedCity(val)}
            displayKey="cityName"
            keyField={"cityId"}
          />
        </div>
      )}

      <div>
        {areas?.length > 0 && (
          <div className="flex flex-row items-center">
            <div
              className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md
justify-start items-center gap-1 inline-flex"
            >
              <UilLocationPoint className="text-gray-500 w-4" />

              <div className="font-normal text-C12 w-12">Area</div>
            </div>

            <GenericCombobox
              label=""
              options={areas}
              selected={selectedArea}
              onChange={(val) => setSelectedArea(val)}
              displayKey="areaName"
              keyField={"areaId"}
            />
          </div>
        )}
      </div>
    </div>
  );
}
